import React, { memo, ReactNode } from 'react';
import { Dialog, DialogActions, DialogContent, DialogTitle, IconButton, Typography } from '@mui/material';
import { faTimes } from '@fortawesome/pro-light-svg-icons';
import Icon from '../Icon';

export interface IModalProps {
    title?: string;
    open: boolean;
    children?: ReactNode;
    contentClassname?: string;
    actions?: ReactNode;
    actionsClassName?: string;
    titleClassName?: string;
    onClose(): void;
}

export const Modal = memo((props: IModalProps) => {
    const { title, open, onClose, children, actions, actionsClassName, titleClassName, contentClassname } = props;

    const paperStyles = {
        width: 'min(520px, calc(100vw - 32px))',
        m: 2,
        borderRadius: 3,
        // Never exceed the viewport; leave room for the fixed bottom navigation on phones.
        maxHeight: { xs: 'calc(100dvh - 96px)', sm: 'calc(100dvh - 48px)' },
    };
    return (
        <Dialog
            fullScreen={false}
            fullWidth
            maxWidth="sm"
            PaperProps={{ sx: paperStyles }}
            onClose={onClose}
            open={open}
            scroll="paper"
            // Render above the fixed bottom navigation (z-index 99999) so actions are never hidden.
            sx={{
                zIndex: 1000000,
                '& .MuiDialog-container': {
                    pb: { xs: '72px', sm: 0 },
                },
            }}
        >
            <DialogTitle className="flex row justify-content-space-between">
                <Typography variant="h6" className={titleClassName}>
                    {title}
                </Typography>
                <IconButton onClick={onClose}>
                    <Icon icon={faTimes} />
                </IconButton>
            </DialogTitle>
            <DialogContent className={contentClassname}>{children}</DialogContent>
            {actions && <DialogActions className={actionsClassName}>{actions}</DialogActions>}
        </Dialog>
    );
});

export default Modal;
